<script>
import log from '@/common/log';
import plans from '@/plans';
import { ADDON_ACCORDION_THRESHOLD, planTypes } from '@/common/constants';
import { isBizPlusContext, isEduSchCmpPlusContext, isProPlusContext } from '@/plans/ZOOM_MEETING/common/utils';

export const filterAddonForKeys = (...args) => {
  const [list, filterForKeys = []] = args
  return list.filter((x) => {
    if (!x) return false;
    if (!filterForKeys.length) return true;
    const For = x.components?.addon.for;
    if (For === '*') return true;
    if (Array.isArray(For)) {
      if (filterForKeys.some((y) => For.includes(y))) return true;
    }
    if (typeof For === 'function') {
      const ForPlanList = For(args);
      if (!Array.isArray(ForPlanList)) return !!ForPlanList
      if (filterForKeys.some((y) => ForPlanList.includes(y))) return true;
    }
    return false;
  });
};

export const planTypesForMeeting = () => {
  return planTypes.map([planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS]);
};

export default {
  props: {
    group: {
      type: String,
      default: undefined,
    },
    filter: {
      type: Function,
      default: list => list,
    },
    filterKeys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isAccordionExpanded: false,
    };
  },
  methods: {
    renderAccordionButton() {
      const toggle = () => {
        this.isAccordionExpanded = !this.isAccordionExpanded;
        this.$nextTick(()=>{
          if(this.isAccordionExpanded){
            const addonDoms = [...document.querySelectorAll(`.opc-tile.opc-addon`)];
            // focus on first expanded addon
            const expanded0 = addonDoms[ADDON_ACCORDION_THRESHOLD];
            if(!expanded0) return;
            return expanded0?.querySelector('.opc-addon__action .zm-button')?.focus();
          }else{
            return document.querySelector('.opc-cfgcore__addon__toggle')?.focus();
          }
        });
      };
      const button = (text, icon) => (
        <zm-button tabindex="0" aria-expanded={this.isAccordionExpanded ? 'true' : 'false'} type="link" class="opc-cfgcore__addon__toggle" onClick={toggle} suffix-icon={icon}>
          {text}
        </zm-button>
      );
      if (this.isAccordionExpanded) return button(this.$t('billing.addon_toggle_less'), 'zm-icon-up');
      return button(this.$t('billing.addon_toggle_more'), 'zm-icon-down');
    },
    renderAddonsWithAccordion(addons) {
      const threshold = ADDON_ACCORDION_THRESHOLD;
      if (addons.length <= threshold) return addons;
      return [
        ...addons.slice(0, this.isAccordionExpanded ? addons.length + 1 : threshold),
        this.renderAccordionButton(),
      ];
    },
    ABTest(addons) {
      if(isBizPlusContext || isProPlusContext || this.$context.is.edu) return this.renderAddonsWithAccordion(addons);
      if (isEduSchCmpPlusContext) return addons
      if(this.$context.type !== planTypes.ZOOM_MEETING) return addons.slice(0, 4);
      return this.renderAddonsWithAccordion(addons);
    },
  },
  render(h) {
    const list = plans.filter((x) => {
      if (!x.components?.addon) return false;
      return true;
    });

    const addons = this.filterKeys.map((key) => list.find((x) => x.key === key)).filter(x => {
      const _group = x.components?.addon?.group;
      const group = typeof _group === 'function' ? _group() : _group;
      return this.group === group;
    });
    const filter = window.__hook_addons_filter__ || this.filter;

    let filtered = filter(addons);
    log('config:addons', filtered);
    if(!filtered.length) return;
    return h(
      'div',
      {},
      [
        this.$slots.default,
        ...this.ABTest(
        filtered.map((x) =>
          h(x.components.addon, {
            on: {
              add: ($data) => {
                this.$emit('add', x.key, $data, x);
              },
            },
          }),
        ),
      )]
    );
  },
};
</script>

<style lang="scss">
.opc-cfgcore__addon {
  &__toggle {
    margin-top: 10px;
  }
}
</style>
